<div class="pagination-container">
    <p-divider></p-divider>
    <div #paginationContainerTemplate>
        <p-paginator
            [id]="id"
            [first]="skip"
            [rows]="take"
            [totalRecords]="totalNumberOfFilteredItems"
            [rowsPerPageOptions]="tablePageSizeOptions"
            [templateRight]="totalNumberOfItemsTemplate"
            [templateLeft]="numberOfItems"
            [dropdownAppendTo]="paginationContainerTemplate"
            (onPageChange)="onPageChangeEvent.emit($event)">
        </p-paginator>
        <ng-template #totalNumberOfItemsTemplate>
            <p>
                {{
                    (totalNumberOfFilteredItems === 1 ? 'paginator.totalItem' : 'paginator.totalItems')
                        | translate: { totalNumber: totalNumberOfFilteredItems }
                }}
            </p>
        </ng-template>
        <ng-template #numberOfItems>
            <div class="paginator-template-text">
                <p-divider [layout]="'vertical'"></p-divider>
                <p>{{ 'paginator.resultsPerPage' | translate }}</p>
            </div>
        </ng-template>
    </div>
</div>
